import { Trash2 } from 'lucide-react'

import { Button } from '@/components/button/button'

import { useDialog } from '@/lib/hooks/use-dialog'
import { cn } from '@/lib/utils'

import { DeleteCasesDialog } from './delete-cases-dialog/delete-cases-dialog'

interface Props {
  caseIds: number[]
  disabled: boolean
}

export const DeleteCasesButton = (props: Props) => {
  const { isDialogOpen, openDialog, closeDialog } = useDialog()

  return (
    <>
      <Button
        className={cn('flex h-9 items-center gap-2')}
        size="sm"
        variant={'black-secondary'}
        disabled={props.disabled}
        onClick={openDialog}
      >
        <Trash2 className="size-4" />
        Delete
      </Button>

      <DeleteCasesDialog open={isDialogOpen} caseIds={props.caseIds} onClose={closeDialog} />
    </>
  )
}
